define('views/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services,
    'services/i18n',
    // Views
    'views/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-header',
    'views/modules/calendar/animated-session/exercise/weight/weight-content',
    'views/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-week',
    'views/parts/form/button',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    //services
    i18n,
    // Views
    VWeightEditHeader,
    VWeightExerciseContent,
    VWeightEditWeek,
    VButton,
    // templates
    TWeightEditContent
) {

    var VWeightEditContent = VWeightExerciseContent.extend({
        headerView: VWeightEditHeader,
        weekView: VWeightEditWeek,
        template: TWeightEditContent,

        regions: _.extend(VWeightExerciseContent.prototype.regions, {
            addSetButton: '.add-set-button',
            removeSetButton: '.remove-set-button'
        }),

        initialize: function(opt) {
            VWeightEditContent.__super__.initialize.call(this, opt);

            _.extend(this.view, {
                addSetButton: new VButton({
                    label: "Add one set",
                    callback: this.onAddSetClick,
                    icon: "fa fa-plus",
                    context: this,
                    block: true,
                    tcClass: false,
                    class: "btn-link"
                }),
                removeSetButton: new VButton({
                    label: i18n.t('calendar:Remove last set'),
                    callback: this.onRemoveSetClick,
                    icon: "fa fa-minus",
                    context: this,
                    block: true,
                    tcClass: false,
                    class: "btn-link"
                })
            });
        },

        render: function() {
            VWeightEditContent.__super__.render.apply(this, arguments);

            var view = this.view,
                zone = this.zone;

            this.assign(view.addSetButton, zone.$addSetButton)
                .assign(view.removeSetButton, zone.$removeSetButton);
        },

        resetList: function() {
            this.collection.reset(this.model.getWeeks().models);
            // render the table header
            this.zone.$list.empty().append(this.view.header.render().el);
            this.removeChildViews({ defer: true });
            this.addAll();
        },

        onAddSetClick: function() {
            var week = this.model.getWeek(this.options.item.getWeek()),
                sets = week.getSets();

            week.set('numSets', sets.length + 1);
        },

        onRemoveSetClick: function() {
            var week = this.model.getWeek(this.options.item.getWeek()),
                sets = week.getSets();

            week.set('numSets', sets.length - 1);
        },

        toggleLoad: _.noop

    });

    return VWeightEditContent;

});

